import { ChartSeries } from '@src/slide/domain/ui-model/element-modeles/chart-models/sub-chart/series-v2/index';


export class RadarChartSeries extends ChartSeries {
    // 标记
    public constructor(sdkSer, option) {
        super(sdkSer, option);
    }
}
